// extracted by mini-css-extract-plugin
module.exports = {"root":"SubscribeAd_root__v2W9U","title":"SubscribeAd_title__auDWw","text":"SubscribeAd_text__NAyFk","close":"SubscribeAd_close__568Ov"};